<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('verification.title') }}
        <Bookmark service_type_code='6420' />
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('verification.title') }} > </span>
            <span class="back_loc">{{ $t('verification.fields.verification') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">

          <ValidationObserver ref="observer">
            <v-form>
              <v-row>
                <v-col cols="12" class="pb-0 pt-0">
                  <h2 class="m_title"><i>*</i> {{ $t('verification.fields.type_of_certification') }}</h2>
                  <div class="input_checkbox_type_basic row ma-0 pa-20 pb-0 pt-0">
                    <ValidationProvider v-slot="{ errors }" :name="$t('verification.fields.type_of_certification')" :rules="{required: true}">
                    <v-radio-group
                      row
                      v-model="search.verifi_cert_type_code"
                      :error-messages="errors"
                      @change="fnInitResult()"
                    >
                      <template v-for="certifyCode in $vuetify.rtl ? verifiCertTypeCodeListAr : verifiCertTypeCodeListEn">
                        <v-radio
                          color="#a01c2a"
                          :key="certifyCode.value"
                          :label="certifyCode.text"
                          :value="certifyCode.value"
                        ></v-radio>
                      </template>
                    </v-radio-group>
                    </ValidationProvider>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="pt-0">
                  <h2 class="m_title"><i>*</i> {{ $t('verification.fields.issue_no') }}</h2>

                  <div class="title__search__wrap">
                    <label class="cautions__title">* {{ $t('verification.fields.issue_no_desc') }}</label>
                    <div class="input_text_type_basic wp100">
                      <ValidationProvider v-slot="{ errors }" :name="$t('verification.fields.issue_no')" :rules="{required: true}">
                      <div class="search__form__t2">
                        <v-text-field
                          dense
                          outlined
                          clearable
                          style="max-width:300px;"
                          class="ft-size12 br_none wp100"
                          v-model="search.issue_no"
                          :error-messages="errors"
                          @change="fnInitResult()"
                        >
                        </v-text-field>
                      </div>
                      <div class="search__form__t2">
                        <vue-recaptcha
                          ref="recaptcha"
                          :sitekey="reCaptchaSiteKey"
                          size="checkbox"
                          @verify="onVerify"
                          @expired="onExpired"
                        >
                        </vue-recaptcha>

                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-btn
                          dense
                          height="40"
                          color="#a01c2a"
                          dark
                          class="ft-size12 capitalize btn_basic br_none mt-30"
                          @click="fnSearch()"
                          :disabled="success ? false : true"
                        >
                          {{ $t('verification.fields.verification') }}
                        </v-btn>
                      </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>

          <!-- 검색 결과 -->
          <v-row v-if="searchResult" class="ma-0">
            <v-col cols="12" class="pb-0">
              <v-row class="search__result__renew ty2">
                <v-col cols="12">
                  <label class="nec_title">{{ $t('verification.fields.issue_no') }}</label>
                  <div class="input_text_type_basic">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12 br_none"
                      v-model="issue_no"
                    >
                    </v-text-field>
                    <!-- {{issue_no}} -->
                  </div>
                </v-col>
              </v-row>

              <v-row class="search__result__renew ty3">
                <v-col cols="12">
                  <label class="nec_title">{{ $t('verification.fields.application_no') }}</label>
                  <div class="input_text_type_basic">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12 br_none"
                      v-model="application_no"
                    >
                    </v-text-field>
                    <!-- {{application_no}} -->
                  </div>
                </v-col>
              </v-row>

              <v-row class="search__result__renew ty3">
                <v-col cols="12">
                  <label class="nec_title">
                    {{ $t('verification.fields.filing_date') }}
                  </label>
                  <div class="input_text_type_basic">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12 br_none"
                      v-model="filing_date"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row class="search__result__renew ty3">
                <v-col cols="12">
                  <label class="nec_title">
                    {{ $t('verification.fields.title') }}
                  </label>
                  <div class="text__input__icontype not__ltr">
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12 text_icon_type text-left br_none"
                        v-model="title_ar"
                      >
                      </v-text-field>
                    </div>
                    <div class="box__title">{{$t('common.common.ar')}}</div>
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <div class="text__input__icontype not__ltr">
                    <div class="box__title">{{$t('common.common.en')}}</div>
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12 text_icon_type text-left br_none"
                        v-model="title_en"
                      >
                      </v-text-field>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="search__result__renew ty3" v-show="search.verifi_cert_type_code == '6301'">
                <v-col cols="12" v-show="search.verifi_cert_type_code == '6301'">
                  <label class="nec_title">{{ $t('verification.fields.exhibition_name') }}</label>
                  <div class="text__input__icontype not__ltr">
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12 text_icon_type text-left br_none"
                        v-model="exhibition_name_ar"
                      >
                      </v-text-field>
                    </div>
                    <div class="box__title">{{$t('common.common.ar')}}</div>
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0" v-show="search.verifi_cert_type_code == '6301'">
                  <div class="text__input__icontype not__ltr">
                    <div class="box__title">{{$t('common.common.en')}}</div>
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12 text_icon_type text-left br_none"
                        v-model="exhibition_name_en"
                      >
                      </v-text-field>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row class="search__result__renew ty3 bt__line" v-show="search.verifi_cert_type_code === '6301'">

                <v-col cols="12" v-show="search.verifi_cert_type_code === '6301'">
                  <label class="nec_title">{{ $t('verification.fields.exhibition_date') }}</label>
                  <v-row>
                    <v-col cols="12" md="6" class="pt-0 pb-0 d-flex align-center">
                      <div class="input_text_type_basic">
                        <v-text-field
                          solo
                          flat
                          dense
                          outlined
                          hide-details
                          readonly
                          append-icon="mdi-calendar"
                          class="date_type br_none"
                          v-model="opening_date"
                        >
                        </v-text-field>
                      </div>
                      <v-spacer class="hidden_lr5">~</v-spacer>
                      <div class="input_text_type_basic">
                        <v-text-field
                          solo
                          flat
                          dense
                          outlined
                          hide-details
                          readonly
                          append-icon="mdi-calendar"
                          class="date_type br_none"
                          v-model="protection_date"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

            </v-col>
          </v-row>

          <v-row v-if="errorMsg" class="search__result__renew ty3 pa-0 pt-25 ma-0">
            <v-col cols="12">
              <div class="success__msg__wrap ty2">
                <v-col cols="12" class="pt-0">
                  <p class="t__title01 ty2">{{ $t('verification.fields.msg_fail') }}</p>
                </v-col>
                <v-col cols="12" class="d-flex pt-0">
                  <v-btn
                    icon
                    color="#a01c2a"
                    class="close__btn__msg"
                      @click="closeErrorMsg()"
                  >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-col>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="successMsg" class="search__result__renew ty3 pa-0 pt-25 ma-0">
            <v-col cols="12" class="pa-0">
              <div class="success__msg__wrap">
                <v-col cols="12" class="pt-0 pb-0">
                  <p class="t__title01">{{ $t('verification.fields.msg_success_1') }}</p>
                  <p class="t__title02">{{ $t('verification.fields.msg_success_2') }}</p>
                </v-col>
                <v-col cols="12" class="d-flex pt-0 pb-0">
                  <v-btn
                    dense
                    color="#2a58ad"
                    dark
                    rounded
                    class="ft-size12"
                    @click="fnGoSearchDetail()"
                  >{{ $t('verification.fields.go_search_system') }}</v-btn>

                  <v-btn
                    icon
                    color="#2a58ad"
                    class="close__btn__msg"
                    @click="closeSuccessMsg()"
                  >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-col>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Bookmark from '@/components/layout/Bookmark'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VueRecaptcha from 'vue-recaptcha'
import store from '@/store'

export default {
  components :{
    ValidationObserver,
    ValidationProvider,
    Bookmark,
    VueRecaptcha
  },
  data () {
    return {
      verifiCertTypeCodeListAr: [],
      verifiCertTypeCodeListEn: [],
      search : {
        verifi_cert_type_code : '',
        issue_no : '',
      },

      errorMsg : false,
      searchResult : false,
      successMsg : false,

      userSeq: store.state.token.user_seq,
      issue_no : '',
      seq : '',
      application_no : '',
      title_ar : '',
      title_en : '',
      filing_date : '',
      exhibition_name_ar: '',
      exhibition_name_en : '',
      opening_date : '',
      protection_date : '',
      applicants : [],
      inventors : [],
      exhibitions: [],
      success: false,

      searchUrl: process.env.VUE_APP_SEARCH_URL,
      reCaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
    }
  },
  beforeCreate(){
    let options = {
      upper_code: '6300'
    }
    utils.fnGetCodeList(options).then(list => {
      this.verifiCertTypeCodeListAr = list.ar
      this.verifiCertTypeCodeListEn = list.en
    })
  },
  mounted() {
    window.scrollTo(0, 0)
    if (this.$route.params.issue_no) {
      this.search.issue_no = this.$route.params.issue_no
      this.search.verifi_cert_type_code = '6301'

      setTimeout(() => {
        this.fnSearch()
      }, 500)
    }
  },
  methods: {

    closeErrorMsg(){
      this.errorMsg = false
    },

    closeSuccessMsg(){
      this.successMsg = false
    },

    fnGoSearchDetail(){
      window.open(this.searchUrl +'"'+ this.application_no +'"', '_blank', '')
    },

    fnInitResult () {
      this.errorMsg = false
      this.searchResult = false
      this.successMsg = false
    },

    fnSearch(){
      this.fnInitResult()

      this.$refs.observer.validate().then((valid) => {
        if(valid){
          let params = {
            verifi_cert_type_code : this.search.verifi_cert_type_code,
            issue_no : this.search.issue_no
          }

          requestApi({
            url: (this.userSeq) ? '/receivings/verification' : '/receivings/common/verification',
            method: 'POST',
            data: params,
            callback: (res) => {
              if(res.res_code === '200'){

                if(utils.isNull(res.data.seq)){
                  this.errorMsg = true
                }else{
                  this.issue_no = params.issue_no

                  this.seq = res.data.seq
                  this.application_no = res.data.application_no
                  this.title_ar = res.data.title_ar
                  this.title_en = res.data.title_en
                  this.filing_date = res.data.filing_date

                  this.applicants = res.data.applicants
                  this.inventors = res.data.inventors
                  this.exhibitions = res.data.exhibitions

                  if (this.exhibitions.length > 0) {
                    this.exhibition_name_ar = this.exhibitions[0].exhibition_name_ar
                    this.exhibition_name_en = this.exhibitions[0].exhibition_name_en
                    this.opening_date = this.exhibitions[0].opening_date
                    this.protection_date = this.exhibitions[0].protection_date
                  }

                  this.searchResult = true
                  if(this.search.verifi_cert_type_code == '6302'){
                    this.successMsg = true
                  }
                }

              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSearch()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },

    getColor (colorbadge) {
        if (colorbadge === 'Important') return '#b22325'
        else if (colorbadge === 'Warning') return '#f59a41'
        else if (colorbadge === 'Inactive') return '#c1c1c1'
        else if (colorbadge === 'Active') return '#99bc44'
        else if (colorbadge === 'Success') return '#00af50'
        else if (colorbadge === 'In Progress') return '#333'
        else if (colorbadge === 'Complete') return '#2a58ad'
        else if (colorbadge === 'Failure') return '#c1c1c1'
        else if (colorbadge === 'claim') return '#a01c2a'
        else if (colorbadge === 'smd') return '#a2c1e2'
        else if (colorbadge === 'pay') return '#98bbbf'

        else return '#1f94a6'
    },

    onVerify (r) {
      let params = {
        response: r
      }
      requestApi({
        url: '/common/recaptcha/api/siteverify',
        method: 'POST',
        data: params,
        callback: (res) => {
          if(res.res_code === '200') {
            this.success = res.data.success
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.onVerify(r)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    onExpired () {
      this.success = false
      this.$refs.recaptcha.reset()
    },
    exec () {
      this.$refs.recaptcha.execute()
    },
    reset () {
      this.$refs.recaptcha.reset()
    },
  },
}
</script>